import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import store from '@/store';
import Cognito from "@/cognito/cognito";
import AuthMypage from "@/authorization/auth_mypage";
import InvoiceApi from "@/consoleapi/api/invoice.ts";
import CallApi from "@/consoleapi/api/call.ts";
import RoutingBehavior from "@/router/routing_behavior";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import('@/views/auth/SignIn.vue'),
    meta: {
      isPublic: true,
      title: 'サインイン',
    },
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: () => import('@/views/auth/SignUp.vue'),
    meta: {
      isPublic: true,
      title: 'サインアップ',
    },
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: () => import('@/views/auth/EmailConfirm.vue'),
    meta: {
      isPublic: true,
      title: 'Eメールの確認',
    },
  },
  {
    path: '/change',
    name: 'change',
    component: () => import('@/views/auth/PasswordChange.vue'),
    meta: {
      title: 'パスワード変更',
    },
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/mypage/Index.vue'),
    meta: {
      title: 'ホーム'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/mypage/Logout.vue'),
    meta: {
      isPublic: true,
      title: 'ログアウト'
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPassword.vue'),
    meta: {
      isPublic: true,
      title: 'パスワードをお忘れの方'
    }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/mypage/account/User.vue'),
    meta: {
      title: 'ユーザー情報'
    }
  },
  {
    path: '/statement',
    name: 'statement',
    component: () => import('@/views/mypage/statement/Index.vue'),
    meta: {
      title: 'ご利用料金照会'
    }
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('@/views/mypage/billing/Billing.vue'),
    meta: {
      title: '請求書情報'
    }
  },
  {
    path: '/billing/info',
    name: 'billing_info',
    component: () => import('@/views/mypage/billing/Info.vue'),
    meta: {
      title: '請求先情報'
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/mypage/terms/Index.vue'),
    meta: {
      title: 'pluscommサービス利用規約'
    }
  },
  {
    path: '/terms/sms',
    name: 'terms_sms',
    component: () => import('@/views/mypage/terms/Sms.vue'),
    meta: {
      title: 'pluscommSMSサービス利用規約'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/mypage/account/Register.vue'),
    meta: {
      title: 'plusommサービス本登録|情報入力',
      isSidebarHidden: 'true',
    }
  },
  {
    path: '/register/call',
    name: 'register_call',
    component: () => import('@/views/mypage/account/Verification.vue'),
    meta: {
      title: 'plusommサービス本登録|電話認証',
      isSidebarHidden: 'true',
    }
  },
  {
    path: '/register/credit',
    name: 'register_credit',
    component: () => import('@/views/mypage/account/Credit.vue'),
    meta: {
      title: 'plusommサービス本登録:支払情報入力',
      isSidebarHidden: 'true',
    }
  },
  {
    path: '/register/done',
    name: 'register_done',
    component: () => import('@/views/mypage/account/Done.vue'),
    meta: {
      title: 'plusommサービス本登録:登録完了',
      isSidebarHidden: 'true',
    }
  },
  {
    path: '/numbers',
    name: 'numbers',
    component: () => import('@/views/mypage/numbers/NumberLists.vue'),
    meta: {
      title: '電話番号管理'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/mypage/contact/Index.vue'),
    meta: {
      title: 'お問い合わせ'
    }
  },
  {
    path: '/outstanding',
    name: 'outstanding',
    component: () => import('@/views/mypage/outstanding/Outstanding.vue'),
    meta: {
      title: 'お支払い処理'
    }
  },
  {
    path: '/change-credit',
    name: 'change_credit',
    component: () => import('@/views/mypage/account/ChangeCredit.vue'),
    meta: {
      title: 'クレジットカード変更'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach((to, from, next) => {
  const auth = new AuthMypage();
  const routing = new RoutingBehavior(to);

  if (routing.doLogout(Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)))) {
    next(routing.getNextQuery());
  }

  auth.getInitialize(Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)))
      .then(response => {
        // console.log(response.data);
        Vue.$cookies.set(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID), response.data.account.id);
        const invoiceApi = new InvoiceApi();
        invoiceApi.setBearerToken(Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        invoiceApi.show(response.data.account.id).then(invoice => {
          // console.log(invoice.data);
          routing.doAuthenticated();
          next(routing.getNextQuery());
        }).catch(error => {
          // console.log(error);
          if(response.data.account.is_phone_verified){
            routing.doCreditPage();
          } else {
            routing.doRegisterCallPage();
          }
          next(routing.getNextQuery());
        });
      })
      .catch(error => {
        if (error.response.status === 412) {
          routing.doIf412Initialized();
        } else if (error.response.status !== 403) {
          routing.doLogout(null);
        }
        // TODO: 403時の対応 エラーページ等の用意
        else if (error.response.status === 403 && !routing.isPublic()) {
          const cognito = new Cognito();
          cognito.refresh(
              Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME)),
              Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_REFRESH_TOKEN))
          ).then(response => {
            //console.log(response);
            Vue.$cookies.set(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN), response.accessToken.getJwtToken());
            next(routing.getNextQuery());
          }).catch(error => {
            //console.log(error.response);
            routing.doLogout(null);
          });
        }else{
          return;
        }
        next(routing.getNextQuery());
      });
});

router.afterEach((to, from) => {
  from;
  if (to.meta && to.meta.title) {
    store.dispatch('title/changePage', to.meta.title)
    if (to.meta && to.meta.isPublic) {
      store.dispatch('status/changePage', to.meta.isPublic)
      store.dispatch('status/changeSidebar', true)
    } else {
      store.dispatch('status/changePage', false)
      if (to.meta.isSidebarHidden) {
        store.dispatch('status/changeSidebar', true)
      } else {
        store.dispatch('status/changeSidebar', false)
      }
    }
  }
})